import { useQuery } from "@tanstack/react-query";
import { api, imgSrc } from "../lib/api";

const fmtData = (iso) => {
    try {
        return new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });
    } catch {
        return iso;
    }
};

const thCls = "font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground pb-2";

export default function MessaggiPanel({ mode }) {
    const key = mode === "prenotazioni" ? "admin-prenotazioni" : "admin-contatti";
    const url = mode === "prenotazioni" ? "/admin/prenotazioni" : "/admin/contatti";
    const { data, isLoading } = useQuery({
        queryKey: [key],
        queryFn: async () => (await api.get(url)).data,
    });

    if (isLoading) {
        return (
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                Caricamento…
            </p>
        );
    }

    if (!data?.length) {
        return (
            <div className="border border-dashed border-line p-12 text-center">
                <p className="font-display text-xl font-bold tracking-tight">
                    {mode === "prenotazioni" ? "Nessuna prenotazione" : "Nessun messaggio"}
                </p>
                <p className="mt-2 text-sm text-muted-foreground">
                    {mode === "prenotazioni"
                        ? "Quando un cliente prenota un ordine dal catalogo, lo vedi qui con il suo codice."
                        : "I messaggi inviati dal form contatti arriveranno qui."}
                </p>
            </div>
        );
    }

    if (mode === "prenotazioni") {
        return (
            <div className="space-y-3" data-testid="admin-prenotazioni-list">
                {data.map((p) => (
                    <article key={p.id} className="border border-line bg-card p-5">
                        <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                                <p className="font-mono text-lg tracking-[0.12em] text-primary font-semibold">
                                    {p.codice}
                                </p>
                                <p className="font-display font-bold text-sm mt-1">{p.prodotto_nome}</p>
                                <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-muted-foreground mt-0.5">
                                    {p.marca} · € {p.prezzo.toFixed(2).replace(".", ",")}
                                </p>
                            </div>
                            <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-muted-foreground">
                                {fmtData(p.created_at)}
                            </p>
                        </div>
                        <div className="mt-3 border-t border-line pt-3 flex flex-wrap gap-x-8 gap-y-2 text-sm">
                            <p>
                                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground block">
                                    Cliente
                                </span>
                                {p.nome}
                            </p>
                            <p>
                                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground block">
                                    Telefono
                                </span>
                                {p.telefono}
                            </p>
                            {p.note && (
                                <p className="max-w-md">
                                    <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground block">
                                        Note
                                    </span>
                                    {p.note}
                                </p>
                            )}
                            <p>
                                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground block">
                                    Stato
                                </span>
                                {p.stato === "in_attesa" ? "In attesa di ritiro" : p.stato}
                            </p>
                        </div>
                    </article>
                ))}
            </div>
        );
    }

    return (
        <div className="space-y-3" data-testid="admin-messaggi-list">
            {data.map((m) => (
                <article key={m.id} className="border border-line bg-card p-5">
                    <div className="flex flex-wrap items-start justify-between gap-3">
                        <div>
                            <p className="font-display font-bold text-sm">{m.nome}</p>
                            <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-muted-foreground mt-0.5">
                                {m.email}
                                {m.telefono ? ` · ${m.telefono}` : ""}
                            </p>
                        </div>
                        <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-muted-foreground">
                            {fmtData(m.created_at)}
                        </p>
                    </div>
                    {m.oggetto && (
                        <p className="mt-3 text-sm font-semibold">
                            Oggetto: {m.oggetto}
                        </p>
                    )}
                    <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{m.messaggio}</p>
                </article>
            ))}
        </div>
    );
}